/**
 * @generated SignedSource<<11e8628b53503710633669f9e3e63904>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SudoDeactivateUser_viewer$data = {
  readonly id: string;
  readonly " $fragmentType": "SudoDeactivateUser_viewer";
};
export type SudoDeactivateUser_viewer$key = {
  readonly " $data"?: SudoDeactivateUser_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SudoDeactivateUser_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SudoDeactivateUser_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "cd7cb81ed759f0ef3068974bb342bcf5";

export default node;
